import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import theme from './theme/theme';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import { AuthProvider } from './contexts/AuthContext';
import { ProductProvider } from './contexts/ProductContext';
import { OrderProvider } from './contexts/OrderContext';
import MarketplaceListing from './pages/marketplace/MarketplaceListing';
import ProductDetails from './pages/marketplace/ProductDetails';
import AddProduct from './pages/marketplace/AddProduct';
import AboutUs from './pages/AboutUs';
import OrdersPage from './pages/dashboard/OrdersPage';
import ChatbotPage from './pages/chatbot/ChatbotPage';
import FarmerRoute from './components/common/FarmerRoute';
import MarketplaceRoute from './components/common/MarketplaceRoute';
import Profile from './pages/Profile';
import ProtectedRoute from './components/common/ProtectedRoute';
import UssdSimulator from './pages/UssdSimulator';
import VerifyEmailPrompt from './pages/auth/VerifyEmailPrompt';
import VerifyEmailSuccess from './pages/auth/VerifyEmailSuccess';
import AgroDealerRoute from './components/common/AgroDealerRoute';
import DashboardRouter from './pages/dashboard/DashboardRouter';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ContactUs from './pages/ContactUs';
import AdminDashboard from './pages/dashboard/AdminDashboard';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <AuthProvider>
          <ProductProvider>
            <OrderProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/verify-email" element={<VerifyEmailPrompt />} />
                  <Route path="/verify-email-success" element={<VerifyEmailSuccess />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password/:token" element={<ResetPassword />} />
                  <Route element={<MarketplaceRoute />}>
                    <Route path="/marketplace" element={<MarketplaceListing />} />
                    <Route path="/marketplace/:id" element={<ProductDetails />} />
                  </Route>
                  <Route path="/about" element={<AboutUs />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                  <Route path="/contact-us" element={<ContactUs />} />
                  <Route path="/ussd" element={<UssdSimulator />} />
                  <Route 
                    path="/chatbot" 
                    element={
                      <ProtectedRoute>
                        <ChatbotPage />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/profile" 
                    element={
                      <ProtectedRoute>
                        <Profile />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/dashboard" 
                    element={
                      <ProtectedRoute>
                        <DashboardRouter />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin-dashboard" 
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/dashboard/add-product" 
                    element={
                      <AgroDealerRoute>
                        <AddProduct />
                      </AgroDealerRoute>
                    } 
                  />
                  <Route 
                    path="/dashboard/orders" 
                    element={
                      <ProtectedRoute>
                        <OrdersPage />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/dashboard/crops" 
                    element={
                      <FarmerRoute>
                        <div>Crop Management - Coming Soon</div>
                      </FarmerRoute>
                    } 
                  />
                  <Route path="/market-prices" element={<div>Market Prices - Coming Soon</div>} />
                </Routes>
              </Layout>
            </OrderProvider>
          </ProductProvider>
        </AuthProvider>
      </Router>
    </ChakraProvider>
  );
}

export default App;
